import script from "./CardChatRDG.vue?vue&type=script&setup=true&lang=js"
export * from "./CardChatRDG.vue?vue&type=script&setup=true&lang=js"

import "./CardChatRDG.vue?vue&type=style&index=0&id=69b43a04&lang=css"

const __exports__ = script;

export default __exports__